/**
 * Turkiz Press — Navigation Component
 *
 * Custom navigation behaviors: mobile menu, sticky header, scroll detection.
 *
 * @package TurkizPress
 * @since   2.0.0
 */

/**
 * Initialize navigation enhancements.
 */
export function init() {
    setupMobileMenu();
    setupStickyHeader();
    setupKeyboardNavigation();
}

/**
 * Mobile menu toggle handler.
 */
function setupMobileMenu() {
    const toggle = document.querySelector( '.turkiz-menu-toggle' );
    const menu   = document.querySelector( '.turkiz-mobile-menu' );

    if ( ! toggle || ! menu ) return;

    toggle.addEventListener( 'click', () => {
        const isOpen = menu.classList.toggle( 'is-open' );
        toggle.setAttribute( 'aria-expanded', isOpen );
        menu.setAttribute( 'aria-hidden', ! isOpen );

        // Trap focus inside menu when open
        if ( isOpen ) {
            menu.querySelector( 'a, button' )?.focus();
        }
    } );

    // Close menu on Escape key
    document.addEventListener( 'keydown', ( e ) => {
        if ( e.key === 'Escape' && menu.classList.contains( 'is-open' ) ) {
            menu.classList.remove( 'is-open' );
            toggle.setAttribute( 'aria-expanded', 'false' );
            toggle.focus();
        }
    } );
}

/**
 * Sticky header behavior on scroll.
 */
function setupStickyHeader() {
    const header = document.querySelector( '.turkiz-sticky-header' );
    if ( ! header ) return;

    let lastScroll = 0;

    window.addEventListener( 'scroll', () => {
        const current = window.scrollY;

        if ( current > 100 ) {
            header.classList.add( 'is-scrolled' );
        } else {
            header.classList.remove( 'is-scrolled' );
        }

        // Hide on scroll down, show on scroll up
        if ( current > lastScroll && current > 200 ) {
            header.classList.add( 'is-hidden' );
        } else {
            header.classList.remove( 'is-hidden' );
        }

        lastScroll = current;
    }, { passive: true } );
}

/**
 * Keyboard navigation: improve submenu access.
 */
function setupKeyboardNavigation() {
    const menuItems = document.querySelectorAll( '.menu-item-has-children' );

    menuItems.forEach( ( item ) => {
        const link    = item.querySelector( ':scope > a' );
        const submenu = item.querySelector( '.sub-menu' );

        if ( ! link || ! submenu ) return;

        link.addEventListener( 'keydown', ( e ) => {
            if ( e.key === 'ArrowDown' || e.key === 'Enter' ) {
                e.preventDefault();
                submenu.querySelector( 'a' )?.focus();
            }
        } );
    } );
}
